import '@rdfjs/data-model';
import '../../rdf.internal.mjs';
import 'http-link-header';
import 'n3';
import '../../rdfjs.mjs';
import { getThing, createThing } from '../../thing/thing.mjs';
import 'cross-fetch';
import { internal_getAcr } from '../control.internal.mjs';
import { DEFAULT_ACCESS_CONTROL, DEFAULT_ACR_ACCESS_CONTROL } from '../internal/getDefaultAccessControlUrl.mjs';
import { setAccessControlResourceThing } from '../internal/setAccessControlResourceThing.mjs';
import { addAgent, removeAgent } from '../matcher.mjs';
import 'uuid';
import { getAgentAccess } from './getAgentAccess.mjs';
import { setDefaultAgentMatcherPolicyMatcherThingIfNotExist } from '../internal/setDefaultAgentMatcherPolicyMatcherThingIfNotExist.mjs';
import { getDefaultAgentMatcherPolicyMatcherUrl } from '../internal/getDefaultAgentMatcherPolicyMatcherUrl.mjs';

//
/** @hidden */
function setAgentAccessMode(resourceWithAcr, webId, name, mode, operation) {
    var _a;
    const matcherUrl = getDefaultAgentMatcherPolicyMatcherUrl(resourceWithAcr, name, mode);
    // Set default Matcher if not exists
    const resourceWithDefaultAgentMatcher = setDefaultAgentMatcherPolicyMatcherThingIfNotExist(resourceWithAcr, name, mode);
    const defaultAgentMatcherThing = (_a = getThing(internal_getAcr(resourceWithDefaultAgentMatcher), matcherUrl)) !== null && _a !== void 0 ? _a : createThing({ url: matcherUrl });
    return setAccessControlResourceThing(resourceWithDefaultAgentMatcher, operation === "add"
        ? addAgent(defaultAgentMatcherThing, webId)
        : removeAgent(defaultAgentMatcherThing, webId));
}
/**
 * Set access for a given Agent.
 *
 * @param resourceWithAcr URL of the Resource you want to set the access for.
 * @param webId WebID of the Agent you want to set the access for.
 * @param access Access Modes you want to set for the agent.
 * @since 1.16.0
 */
async function setAgentAccess(resourceWithAcr, webId, access) {
    const agentAccessModes = await getAgentAccess(resourceWithAcr, webId);
    // Add Agent to Default Matchers (including member) if access mode is different from what exists
    if (typeof access.read === "boolean" &&
        agentAccessModes.read !== access.read) {
        resourceWithAcr = setAgentAccessMode(resourceWithAcr, webId, DEFAULT_ACCESS_CONTROL, "read", access.read ? "add" : "remove");
    }
    if (typeof access.append === "boolean" &&
        agentAccessModes.append !== access.append) {
        resourceWithAcr = setAgentAccessMode(resourceWithAcr, webId, DEFAULT_ACCESS_CONTROL, "append", access.append ? "add" : "remove");
    }
    if (typeof access.write === "boolean" &&
        agentAccessModes.write !== access.write) {
        resourceWithAcr = setAgentAccessMode(resourceWithAcr, webId, DEFAULT_ACCESS_CONTROL, "write", access.write ? "add" : "remove");
    }
    if (typeof access.controlRead === "boolean" &&
        agentAccessModes.controlRead !== access.controlRead) {
        resourceWithAcr = setAgentAccessMode(resourceWithAcr, webId, DEFAULT_ACR_ACCESS_CONTROL, "controlRead", access.controlRead ? "add" : "remove");
    }
    if (typeof access.controlWrite === "boolean" &&
        agentAccessModes.controlWrite !== access.controlWrite) {
        resourceWithAcr = setAgentAccessMode(resourceWithAcr, webId, DEFAULT_ACR_ACCESS_CONTROL, "controlWrite", access.controlWrite ? "add" : "remove");
    }
    return resourceWithAcr;
}

export { setAgentAccess };
